import { useEffect } from "react";
import { usePatchPortfolioInvestmentMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPortfolioInvestmentMutation";
import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getPortfolioTitle } from "web_myplann/Portfolio/Components/PortfolioSections/portfolioListItemHelpers";
import { getInvestmentFormSchema } from "web_myplann/Portfolio/Forms/InvestmentForm/investmentFormSchema";
import { mapPortfolioToInvestmentForm } from "web_myplann/Portfolio/Forms/InvestmentForm/mapPortfolioToInvestmentForm";
import { useEditPortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useEditPortfolioForm";

type UseEditInvestmentFormArgs = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const useEditInvestmentForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: UseEditInvestmentFormArgs) => {
	const { t } = useResource();
	const { mutate, isPending } =
		usePatchPortfolioInvestmentMutation(portfolioId);

	const { form, onSubmit } = useEditPortfolioForm({
		schema: getInvestmentFormSchema(t),
		defaultValues: mapPortfolioToInvestmentForm(portfolio),
		mutate,
		successToast: t(Resources.Portfolio.EditPortfolio.savedToast, {
			type: getPortfolioTitle(portfolio, t),
		}),
		redirectTo: detailRoute,
	});

	useEffect(() => {
		form.trigger();
	}, [form.trigger]);

	return { form, onSubmit, isPending };
};
